import { render } from "./TheMenuRoleTree.vue?vue&type=template&id=e0bd3fc6"
import script from "./TheMenuRoleTree.vue?vue&type=script&lang=js"
export * from "./TheMenuRoleTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__